export const FeatureTypes  =  {
    changeHeaderColor: 'CHANGE_HEADER_COLOR',
    SET_AUTH_MODAL: 'SET_AUTH_MODAL'
};